class Wishlist {
  constructor() {
    this.wishlistKey = "shopify-wishlist";
    this.wishlist = this.getWishlist();
    this.init();
  }

  init() {
    this.updateButtons();
    this.updateHeaderCount();
    this.bindEvents();
    if (document.getElementById("WishlistGrid")) {
      this.renderPage();
    }
  }

  getWishlist() {
    const data = localStorage.getItem(this.wishlistKey);
    return data ? JSON.parse(data) : [];
  }

  setWishlist(wishlist) {
    localStorage.setItem(this.wishlistKey, JSON.stringify(wishlist));
    this.wishlist = wishlist;
    this.updateHeaderCount();
    this.updateButtons();

    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: { wishlist: this.wishlist },
      }),
    );

    // ウィッシュリストページの場合は再描画
    if (document.getElementById("WishlistGrid")) {
      this.renderPage();
    }
  }

  toggle(id, handle) {
    let wishlist = this.getWishlist();
    const stringId = String(id);
    const index = wishlist.findIndex((item) => {
      const itemId = typeof item === "object" ? String(item.id) : String(item);
      return itemId === stringId;
    });

    if (index === -1) {
      wishlist.push({ id: stringId, handle: handle });
    } else {
      wishlist.splice(index, 1);
    }
    this.setWishlist(wishlist);
  }

  async renderPage() {
    const grid = document.getElementById("WishlistGrid");
    const empty = document.getElementById("WishlistEmpty");
    const loading = document.getElementById("WishlistLoading");
    const wishlist = this.getWishlist();

    console.log("Wishlist: Starting renderPage", wishlist);

    if (wishlist.length === 0) {
      console.log("Wishlist: Empty");
      if (grid) {
        grid.style.display = "none";
        grid.innerHTML = "";
      }
      if (loading) loading.style.display = "none";
      if (empty) {
        empty.classList.remove("hidden");
        empty.style.display = "flex";
      }
      return;
    }

    if (loading) {
      loading.classList.remove("hidden");
      loading.style.display = "block";
    }
    if (grid && grid.innerHTML === "") {
      // まだ中身がない時だけ隠す（削除時は中身があるので隠さない方がガタつかない）
      grid.style.display = "none";
    }
    if (empty) {
      empty.classList.add("hidden");
      empty.style.display = "none";
    }

    const productHtmls = await Promise.all(
      wishlist.map(async (item) => {
        const handle = typeof item === "object" ? item.handle : item;
        if (!handle) return "";

        try {
          const url = `/products/${handle}?view=wishlist-item`;
          const response = await fetch(url);
          if (!response.ok) return "";
          const html = await response.text();
          if (html.includes("product-item")) {
            return html;
          }
          return "";
        } catch (e) {
          return "";
        }
      }),
    );

    const filteredHtmls = productHtmls.filter((html) => html !== "");

    if (loading) loading.style.display = "none";

    if (filteredHtmls.length === 0) {
      if (grid) {
        grid.style.display = "none";
        grid.innerHTML = "";
      }
      if (empty) {
        empty.classList.remove("hidden");
        empty.style.display = "flex";
      }
    } else {
      if (grid) {
        grid.innerHTML = filteredHtmls.join("");
        grid.classList.remove("hidden");
        grid.style.display = "grid";
      }
      if (empty) {
        empty.style.display = "none";
      }
    }
    this.updateButtons();
  }

  updateButtons() {
    this.wishlist = this.getWishlist();
    document.querySelectorAll("[data-wishlist-button]").forEach((button) => {
      const id = String(button.dataset.productId);
      const isActive = this.wishlist.some((item) => {
        const itemId =
          typeof item === "object" ? String(item.id) : String(item);
        return itemId === id;
      });
      if (isActive) {
        button.classList.add("is-active");
        button.setAttribute(
          "aria-label",
          window.wishlistStrings?.remove_from_wishlist || "お気に入りから削除",
        );
      } else {
        button.classList.remove("is-active");
        button.setAttribute(
          "aria-label",
          window.wishlistStrings?.add_to_wishlist || "お気に入りに追加",
        );
      }
    });
  }

  updateHeaderCount() {
    const counts = document.querySelectorAll(".js-wishlist-count");
    const count = this.getWishlist().length;
    counts.forEach((el) => {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
  }

  bindEvents() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest("[data-wishlist-button]");
      if (button) {
        e.preventDefault();
        const id = button.getAttribute("data-product-id");
        const handle = button.getAttribute("data-product-handle");

        // ウィッシュリストページでの削除なら即座に消す演出
        if (document.getElementById("WishlistGrid")) {
          const productItem = button.closest(".product-item");
          if (productItem && button.classList.contains("is-active")) {
            productItem.style.transition =
              "opacity 0.3s ease, transform 0.3s ease";
            productItem.style.opacity = "0";
            productItem.style.transform = "scale(0.9)";
            setTimeout(() => {
              if (productItem.parentNode) {
                // 完全に消す。renderPageが走るまでの繋ぎ。
                productItem.style.display = "none";
              }
            }, 300);
          }
        }

        this.toggle(id, handle);
      }
    });

    const observer = new MutationObserver((mutations) => {
      const hasAddedNodes = mutations.some((m) => m.addedNodes.length > 0);
      if (hasAddedNodes) this.updateButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.wishlist = new Wishlist();
});
